import { logStartGreyError } from 'owa-analytics-start';
import type { ILogger } from './ILogger';

export class Logger implements ILogger {
    eventName: string;
    hasEnded = false;
    private startTime: number | undefined;
    checkPoints: {
        [key: string]: number;
    };
    customData: {
        [key: string]: string;
    };
    duration: number | undefined;

    constructor(eventName: string) {
        this.eventName = eventName;
        this.startTime = Date.now();
        this.checkPoints = {};
        this.customData = {};
    }

    addCustomData(key: string, value: string): void {
        if (!this.customData) {
            this.customData = {};
        }
        this.customData[key] = value;
    }

    addCustomError(eventName: string, error?: Error): void {
        if (!this.customData) {
            this.customData = {};
        }
        this.customData[eventName + '_Message'] = error?.message ?? '';
        this.customData[eventName + '_Stack'] = error?.stack ?? '';
    }

    addCheckpoint(checkPoint: string): void {
        const time = this.timeFromStart();
        this.addToCheckPointEvents(checkPoint, time);
    }

    logLatency(): void {
        this.addCheckpoint('TokenFetchLatency');
    }

    private addToCheckPointEvents(key: string, time: number) {
        if (!this.checkPoints) {
            this.checkPoints = {};
        }
        this.checkPoints[key] = time;
    }

    end(): void {
        if (!this.hasEnded) {
            this.hasEnded = true;

            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logStartGreyError('OWA_TokenProvider_LogStartGreyError', undefined, undefined, {
                ...this.customData,
                ...this.checkPoints,
                dynamicEventName: this.eventName,
            });
        }
    }

    private timeFromStart(): number {
        return this.startTime != null ? Date.now() - this.startTime : 0;
    }
}
